import api from "lib/api/api";

export const fetchAllSubmissions = () => async (dispatch) => {
    try {
        dispatch({ type: 'FETCH_SUBMISSIONS_REQUEST' });
        const response = await api.get('/consultant/submissions');
        dispatch({
            type: 'FETCH_SUBMISSIONS_SUCCESS',
            payload: Array.isArray(response.data) ? response.data : []
        });
    } catch (error) {
        dispatch({
            type: 'FETCH_SUBMISSIONS_FAILURE',
            payload: error.response?.data || 'Failed to fetch submissions'
        });
    }
};

export const updateSubmissionStatus = (id, status) => async (dispatch) => {
    try {
        dispatch({ type: 'UPDATE_SUBMISSION_STATUS_REQUEST' });
        const response = await api.put(`/consultant/submissions/${id}/status`, null, { params: { status } });
        dispatch({
            type: 'UPDATE_SUBMISSION_STATUS_SUCCESS',
            payload: response.data
        });
        dispatch(fetchAllSubmissions()); // Refresh list
    } catch (error) {
        dispatch({
            type: 'UPDATE_SUBMISSION_STATUS_FAILURE',
            payload: error.response?.data || 'Failed to update status'
        });
    }
};
